class SolyraSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
    this.previousButton = this.querySelector('[data-slide-previous]');
    this.nextButton = this.querySelector('[data-slide-next]');
    this.autoplay = this.dataset.autoplay === 'true';
    this.interval = Number.parseInt(this.dataset.interval, 10) || 6000;
    this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
    this.onBlockSelect = this.handleBlockSelect.bind(this);

    if (this.currentIndex < 0) this.currentIndex = 0;
    this.addEventListener('shopify:block:select', this.onBlockSelect);
    if (this.slides.length <= 1) return;

    this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goTo(index));
    });

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    this.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  handleBlockSelect(event) {
    const selectedSlide = event.target.closest('[data-slide]');
    const selectedIndex = this.slides.indexOf(selectedSlide);

    if (selectedIndex < 0) return;

    this.stopAutoplay();
    this.goTo(selectedIndex);
  }

  goTo(index) {
    const nextIndex = (index + this.slides.length) % this.slides.length;
    if (nextIndex === this.currentIndex) return;

    this.slides[this.currentIndex]?.classList.remove('is-active');
    this.slides[this.currentIndex]?.setAttribute('aria-hidden', 'true');
    this.dots[this.currentIndex]?.setAttribute('aria-current', 'false');
    this.dots[this.currentIndex]?.setAttribute('aria-selected', 'false');

    this.currentIndex = nextIndex;

    this.slides[this.currentIndex]?.classList.add('is-active');
    this.slides[this.currentIndex]?.setAttribute('aria-hidden', 'false');
    this.dots[this.currentIndex]?.setAttribute('aria-current', 'true');
    this.dots[this.currentIndex]?.setAttribute('aria-selected', 'true');
  }

  startAutoplay() {
    if (!this.autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.stopAutoplay();
    this.timer = window.setInterval(() => this.goTo(this.currentIndex + 1), this.interval);
  }

  stopAutoplay() {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  }
}

if (!customElements.get('solyra-slideshow')) {
  customElements.define('solyra-slideshow', SolyraSlideshow);
}
